export const existingRoutes = {
  '/': true,
  '/dashboard': true,
  '/onboarding': true,
  '/products': true,
  '/products/shipments': true,
  '/coproducers': true,
  '/affiliates': true,
  '/integrations': true,
  '/integrations/webhook': true,
  '/integrations/xtracky': true,
  '/integrations/utmify': true,
  '/integrations/vturb': true,
  '/integrations/hotzapp': true,
  '/products/edit-product/:id': true,
  '/products/edit-product/:id/offers': true,
  '/products/edit-product/:id/upsells': true,
  '/products/edit-product/:id/upsells/create': true,
  '/products/edit-product/:id/affiliate': true,
  '/products/edit-product/:id/checkouts': true,
  '/products/edit-product/:id/checkouts/:checkoutId': true,
  '/products/edit-product/:id/order-bumps': true,
  '/products/edit-product/:id/pixels': true,
  '/products/edit-product/:id/coproductor': true,
  '/products/edit-product/:id/coupons': true,
  '/products/edit-product/:id/funnel': true,
  '/products/create-products': true,
  '/my-account': true,
  '/email-verified': true,
  '/financial': true,
  '/sales': true,
  '/sales/sales-details/:id': true,
  '/signatures': true,
  '/signatures/subscriptions-details/:publicId': true,
  '/refer-and-earn': true,
  '/team': true,
  '/invitation-affiliate/:productId': true,
  '/invitation-affiliate-confirm': true,
  '/invitation-partner/:productId': true,
  '/invitation-partner-confirm': true,
  '/invitation-accept/:token': true,
  '/invitation-accept-confirm': true,
  '/reports': true,
  '/reports/cart-abandonment': true,
  '/reports/profit_per_affiliate': true,
  '/logout': true,
};
